import { z } from 'zod';
import { FederalState, PruefWeg } from '../enums.js';
export const pruefer = z.object({
    id: z.number().int().positive(),
    salutation: z.string().nullable().optional(),
    title: z.string().nullable().optional(),
    firstName: z.string(),
    lastName: z.string(),
    fullName: z.string(),
    registrationNumber: z.string().nullable().optional(),
    fachrichtung: z.string().nullable().optional(),
    organization: z.string().nullable().optional(),
    federalState: FederalState.nullable().optional(),
    pruefWeg: PruefWeg.nullable().optional(),
    email: z.string().email().nullable().optional(),
    phone: z.string().nullable().optional(),
    street: z.string().nullable().optional(),
    zip: z.string().nullable().optional(),
    city: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),
    archived: z.boolean().default(false),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const createPrueferRequest = pruefer
    .omit({
    id: true,
    fullName: true,
    archived: true,
    createdAt: true,
    updatedAt: true,
})
    .extend({
    firstName: z.string().min(1),
    lastName: z.string().min(1),
});
export const updatePrueferRequest = createPrueferRequest.partial();
export const prueferListResponse = z.object({
    items: z.array(pruefer),
    total: z.number().int().nonnegative(),
});
